import { Navigate, Route, Routes } from 'react-router-dom'
import { ReviewsAccessLayout } from 'pages/reviews/layout/ReviewsAccessLayout'
import { ReviewsPageLayout } from 'pages/reviews/layout/ReviewsPageLayout'
import { AllReviews, CreateReview } from 'pages/reviews/pages'
import { ReviewsRoutes } from './type'

export const ReviewsRouter = () => {
  return (
    <Routes>
      <Route element={<ReviewsAccessLayout />}>
        <Route element={<ReviewsPageLayout />}>
          <Route index element={<AllReviews />} />
          <Route path={`${ReviewsRoutes.create}`} element={<CreateReview />} />
          <Route path={'*'} element={<Navigate to={'/'} />} />
        </Route>
      </Route>
    </Routes>
  )
}
